import { faCalendar } from '@fortawesome/free-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, navigate } from 'gatsby'
import React, { useContext, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Phone from '../../assets/phone.svg'
import UserIcon from '../../assets/user.svg'
import ModalTeLlamamos from '../../components/modal/teLlamamos/index'
import * as UserActions from '../../context/actions/userActions'
import AppContext, { IAppState } from '../../context/context'
import route from '../../utils/route'
import styles from './headerYellow.module.scss'
import { citaPreviaSteps, CitaPreviaEnum } from '../CitaPrevia/CitaPreviaSteps'
import { startCitaPrevia } from '../../context/actions/citaPreviaActions'
import { connect } from 'react-redux'
import { selectFullName } from '../../context/selectors/userSelectors'
import HeaderYellowSpecific from '../../../specific/components/headers/HeaderYellowSpecific'

const UserOptionsContent = ({ userName, onLogout }) => (
  <section className={styles.right_part}>
    <div className={styles.user}>
      <Link to={route('area-privada')} className={styles.private_area_link}>
        <UserIcon className={styles.login_icon} />
        {userName}
      </Link>
    </div>
    <div className={styles.logout}>
      <div className={styles.logout_link}>
        <a onClick={onLogout} href="/logout">
          <FormattedMessage id="home.logout" />
        </a>
      </div>
    </div>
  </section>
)

const UserOptions = connect((state: IAppState) => ({
  userName: selectFullName(state),
}))(UserOptionsContent)

const AnonymousUserOptions = () => (
  <div className={styles.right_part}>
    <div className={styles.register}>
      <Link to={route('register')} className={styles.register_link}>
        <FormattedMessage id="home.register" />
      </Link>
    </div>
    <div className={styles.login}>
      <Link to={route('login.index')} className={styles.login_link}>
        <UserIcon className={styles.login_icon} />
        <FormattedMessage id="home.login" />
      </Link>
    </div>
  </div>
)

interface PathProps {
  esPath: string
  caPath: string
}

const HeaderYellow = ({ esPath, caPath }: PathProps) => {
  const { userInfo, userDispatch, dispatch } = useContext(AppContext)
  const { loggedIn } = userInfo
  const [openModal, setOpenModal] = useState(false)

  const onLogout = event => {
    event.preventDefault()
    userDispatch(UserActions.logout())
  }

  const goToCitaPrevia = e => {
    e.preventDefault()
    const url = document.location.pathname
    dispatch(startCitaPrevia(url))
    navigate(citaPreviaSteps[CitaPreviaEnum.SELECCION_TALLER].route)
  }

  return (
    <div className={styles.yellow_header}>
      <div className={styles.yellow_header_wrapper}>
        <div className={styles.left_part}>
          <HeaderYellowSpecific esPath={esPath} caPath={caPath} />
          <a
            href="#"
            className={styles.call_you}
            onClick={() => setOpenModal(true)}>
            <Phone width="15" height="15" className={styles.call_you_icon} />
            <FormattedMessage id="home.call" />
          </a>
          <ModalTeLlamamos setOpenModal={setOpenModal} openModal={openModal} />
          <a onClick={goToCitaPrevia} href="#" className={styles.calendar}>
            <FontAwesomeIcon
              icon={faCalendar}
              className={styles.calendar_icon}
            />
            <FormattedMessage id="taller-card.appointment" />
          </a>
        </div>
        {loggedIn ? (
          <UserOptions onLogout={onLogout} />
        ) : (
          <AnonymousUserOptions />
        )}
      </div>
    </div>
  )
}

export default HeaderYellow
